export const UNLIMITED_ENTITLEMENT_PROFILE_KEY = "unlimited";

// Entitlements are one flat set of profile keys; which of them names the whole
// subscription rather than an add-on is a catalog presentation split, and the
// client's intent event and the server's activation event have to report
// plan_name identically for the funnel between them to join.
export const PLAN_ENTITLEMENT_PROFILE_KEYS: ReadonlySet<string> = new Set([
  UNLIMITED_ENTITLEMENT_PROFILE_KEY,
]);

// A subscription assembled from modules alone carries no plan key to name it.
export const MODULAR_PLAN_NAME = "Modular";
